















import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { DashboardWidgetHeaderColor } from '../../types/enums/dashboard-widget-header-color';
import { DashboardWidgetValueColor } from '../../types/enums/dashboard-widget-value-color';
import DashboardWidget from '../DashboardWidget.vue';
import type { DashboardWidgetData } from '../../types/dashboard-widget-data';

export default defineComponent({
  name: 'HitRateWidget',
  components: {
    DashboardWidget,
  },
  props: {
    hit: {
      type: Object as PropType<DashboardWidgetData>,
      required: true,
    },
    hitLast: {
      type: Object as PropType<DashboardWidgetData>,
      required: true,
    },
  },
  setup(props) {
    const value = computed(() => {
      const value = Math.round((props.hit.count / props.hit.value) * 100);
      return `${value || 0}%`;
    });
    const subValue = computed(() => {
      const value = Math.round((props.hitLast.count / props.hitLast.value) * 100);
      return `${value || 0}%`;
    });
    const valueTitle = computed(() => `${props.hit.count}/${props.hit.value} ${t('Deals')}`);

    return {
      value,
      subValue,
      valueTitle,
      DashboardWidgetHeaderColor,
      DashboardWidgetValueColor,
    };
  },
});
